export class DialogData<T> {
    public data: T;
}
